import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Form, Modal, Table } from "react-bootstrap";

const API_URL = process.env.REACT_APP_API_URL;

const SeasonList = () => {
  const [seasons, setSeasons] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentSeason, setCurrentSeason] = useState({
    id: null,
    name: "",
    date_start: "",
    date_end: "",
    status: 1,
  });

  const fetchSeasons = async () => {
    try {
      const res = await axios.get(`${API_URL}/seasons`);
      setSeasons(res.data);
    } catch (error) {
      console.error("Error fetching seasons:", error);
    }
  };

  useEffect(() => {
    fetchSeasons();
  }, []);

  const handleClose = () => {
    setShowModal(false);
    setCurrentSeason({
      id: null,
      name: "",
      date_start: "",
      date_end: "",
      status: 1,
    });
  };

  const handleShowAdd = () => {
    setIsEditing(false);
    setCurrentSeason({
      id: null,
      name: "",
      date_start: "",
      date_end: "",
      status: 1,
    });
    setShowModal(true);
  };

  const handleShowEdit = (season) => {
    setIsEditing(true);
    setCurrentSeason(season);
    setShowModal(true);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setCurrentSeason((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isEditing) {
      await axios.put(`${API_URL}/seasons/${currentSeason.id}`, currentSeason);
    } else {
      await axios.post(`${API_URL}/seasons`, currentSeason);
    }
    fetchSeasons();
    handleClose();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Bạn có chắc chắn muốn xóa mùa giải này?")) {
      await axios.delete(`${API_URL}/seasons/${id}`);
      fetchSeasons();
    }
  };

  const handleStatusToggle = async (season) => {
    const updatedSeason = { ...season, status: season.status === 1 ? 0 : 1 };
    try {
      await axios.put(`${API_URL}/seasons/${season.id}`, updatedSeason);
      fetchSeasons();
    } catch (error) {
      console.error("Error updating season status:", error);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Quản lý Mùa giải</h2>
        <Button variant="primary" onClick={handleShowAdd}>
          Thêm Mùa giải
        </Button>
      </div>

      <Table striped bordered hover>
        <thead className="table-light">
          <tr>
            <th>ID</th>
            <th>Tên Mùa giải</th>
            <th>Ngày bắt đầu</th>
            <th>Ngày kết thúc</th>
            <th>Trạng thái</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          {seasons.map((season) => (
            <tr key={season.id}>
              <td>{season.id}</td>
              <td>{season.name}</td>
              <td>{season.date_start}</td>
              <td>{season.date_end}</td>
              <td>
                <Form.Check
                  type="switch"
                  id={`season-switch-${season.id}`}
                  checked={season.status === 1}
                  onChange={() => handleStatusToggle(season)}
                  label={season.status === 1 ? "Hoạt động" : "Khóa"}
                />
              </td>
              <td>
                <Button
                  variant="warning"
                  size="sm"
                  onClick={() => handleShowEdit(season)}
                >
                  Sửa
                </Button>{" "}
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDelete(season.id)}
                >
                  Xóa
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditing ? "Sửa Mùa giải" : "Thêm Mùa giải"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Tên Mùa giải</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={currentSeason.name}
                onChange={handleFormChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Ngày bắt đầu</Form.Label>
              <Form.Control
                type="text"
                name="date_start"
                placeholder="YYYY-MM-DD"
                value={currentSeason.date_start}
                onChange={handleFormChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Ngày kết thúc</Form.Label>
              <Form.Control
                type="text"
                name="date_end"
                placeholder="YYYY-MM-DD"
                value={currentSeason.date_end}
                onChange={handleFormChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Trạng thái</Form.Label>
              <Form.Select
                name="status"
                value={currentSeason.status}
                onChange={handleFormChange}
              >
                <option value="1">Hoạt động</option>
                <option value="0">Khóa</option>
              </Form.Select>
            </Form.Group>
            <Button variant="secondary" onClick={handleClose} className="me-2">
              Hủy
            </Button>
            <Button variant="primary" type="submit">
              Lưu
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SeasonList;
